import React from "react";
import style from "./index.module.scss";
interface TitleProps {
    title: string;
    children?: React.ReactNode;
}
export default function Title({ title, children }: TitleProps) {
    return (
        <div className={style.title}>
            <span>{title}</span>
            <div>{children}</div>
        </div>
    );
}
